import { render, staticRenderFns } from "./IcoHeadset.vue?vue&type=template&id=116c71a4"
import script from "./IcoHeadset.vue?vue&type=script&lang=js"
export * from "./IcoHeadset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports